// extracted by mini-css-extract-plugin
export default {"option_container":"language-selector_option_container__ZyPfT","flag":"language-selector_flag__tV+zh"};